function FormatNumber(number) {
  const numStr = number.toString();
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' '); 
}


export default FormatNumber;